import React from 'react';
import styled from 'styled-components';
import { FiPlus } from 'react-icons/fi';

interface AddProductTileProps {
    onClick: () => void;
    boxId: string;
}

export const AddProductTile: React.FC<AddProductTileProps> = ({ onClick, boxId }) => {
    return (
        <ProductContainer onClick={onClick} data-boxid={boxId}>
            <ProductImageContainer>
                <PlusIconContainer>
                    <FiPlus size={40} />
                </PlusIconContainer>
            </ProductImageContainer>
            <ProductDetails>
                <ProductName>Ajouter un produit</ProductName>
            </ProductDetails>
        </ProductContainer>
    );
};

const ProductContainer = styled.div`
    display: flex;
    border-radius: ${({ theme }) => theme.borderRadius};
    border: 1px solid ${({ theme }) => theme.lightBorderColor};
    overflow: hidden;
    cursor: pointer;
    transition: all 0.2s ease;
    width: 100%;

    &:hover {
        background-color: ${({ theme }) => theme.cardBackgroundColor};
        transform: translateY(-2px);
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    }
`;

const ProductImageContainer = styled.div`
    position: relative;
    width: 100px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.cardBackgroundColor};
`;

const PlusIconContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.ctaPrimaryColor};
`;

const ProductDetails = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 10px;
    border-left: 1px solid ${({ theme }) => theme.lightBorderColor};
    color: ${({ theme }) => theme.textColor};
`;

const ProductName = styled.span`
    font-size: 18px;
    font-weight: 600;
    color: ${({ theme }) => theme.ctaPrimaryColor};
`;
